import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toggleChat } from 'apps/promo/actions/chatAction';
import { Breadcrumbs } from 'apps/promo/components/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import ZendeskHelpSearch from 'apps/promo/components/help/ZendeskHelpSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelp.module.css';

const ZendeskHelpSectionPage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const section = props.sections?.find((s) => s.id === sectionIdNumber);

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;
    const urlParams = useGetQueryParams();

    const articles = props.articles?.map((article) => {
        return (
            <PromoRow indent="adaptive-24-32" key={article.id} lastChildNoMargin>
                <a
                    className={styles.helpLink}
                    href={getHelpCenterUrl(`${url}/category/${props.category?.id}/section/${sectionId}/article/${article.id}`, urlParams)}
                >
                    <PromoText>
                        {article.promoted && <PromoIcon name="star-filled" color="primary" size="16px" rightIndent="8px" />}
                        {article.name}
                    </PromoText>
                    <PromoIcon name="chevron-right" size="16px" />
                </a>
            </PromoRow>
        );
    });

    const breadcrumbs = [
        { name: 'Paysend', url: getHelpCenterUrl(url, urlParams) },
        { name: props.category?.name, url: getHelpCenterUrl(`${url}/category/${props.category?.id}`, urlParams) },
        { name: section?.name },
    ];

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <Breadcrumbs breadcrumbsItems={breadcrumbs} />
                <HeadingSection title={section?.name} titleTag={'h1'} />
                <PromoRow indent="64px">{articles}</PromoRow>
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    articles: extra?.zendeskHelpData?.articles,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpSectionPage));
